<template>
  <div class="flex flex-col gap-2">
    <label :for="id" class="font-medium text-dark-600 dark:text-dark-50">{{ label }}</label>
    <InputText :id="id" :name="name" type="text" :value="displayValue" @input="handleInput"
      class="w-full border border-gray-400 rounded-md px-3 py-2 text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-dark-900"
      :class="input_class" :disabled="disabled" :invalid="!valid" fluid />
    <Message v-if="!valid" size="small" severity="error" variant="simple">{{ errorMessage }}
    </Message>
  </div>
</template>

<script>
import { formatRupiah } from '@/helpers/formatRupiah';
import { InputText, Message } from 'primevue';

export default {
  name: 'InputRupiah',
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    input_class: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Number, String],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  components: {
    Message, InputText
  },
  data() {
    return {
      displayValue: formatRupiah(this.modelValue || 0)
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.displayValue = formatRupiah(newVal || 0);
      },
      immediate: true
    }
  },
  methods: {
    handleInput(event) {
      // Remove non-digit characters and convert to number
      const numericValue = parseInt(event.target.value.replace(/\D/g, '')) || 0;

      // Update the display value with formatting
      this.displayValue = formatRupiah(numericValue);

      // Emit the raw numeric value
      this.$emit('update:modelValue', numericValue);

      // Set cursor position to end
      const input = event.target;
      setTimeout(() => {
        input.selectionStart = input.selectionEnd = input.value.length;
      }, 0);
    }
  }
}
</script>
